<template>
	<v-container>
		<v-col class="px-0">
			<v-row>
				<v-col cols="12" class="text-right">
					<v-btn depressed color="primary" class="rounded-xl" @click="goPrint">
						<v-icon small color="white">mdi-printer</v-icon>
						<span class="pl-2">Print</span>
					</v-btn>
				</v-col>
			</v-row>
			<div id="section-to-print" class="overflow-hidden" v-if="!loading">
				<div class="my-3">
					<img width="90" height="auto" src="/img/ic-logo.svg">
					<v-row>
						<v-col cols="12" sm="12">
							<div class="font-size-11 font-weight-500">Damai Sinergi Nusantara</div>
							<div class="font-size-10">Jl Raya Ringin Ngulanwetan Pogalan - Trenggalek - Jawa Timur INDONESIA 66371</div>
							<div class="font-size-10">Hp : 0822-3114-0366</div>
							<div class="font-size-10">Email : ybfcpanzer@yahoo.com</div>
						</v-col>
						<v-col cols="12" class="pt-0">
							<div class="border-bottom border-grey border-2px"></div>
						</v-col>
					</v-row>
				</div>

				<v-row>
					<v-col cols="6" md="6">
						<div>
							<div class="font-size-10">Tanggal</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailTransaction.transaction_datetime | tanggal }}</div>
						</div>
					</v-col>
					<v-col cols="6" md="6">
						<div class="text-right">
							<div class="font-size-10">Status</div>
							<div class="font-size-10 cl-secondary font-weight-500 ml-2">
								<v-chip
								:color="detailTransaction.transaction_status | toColorTransaction"
								outlined
								class="mt-2 px-5 text-uppercase font-weight-bold font-weight-14"
								>{{ detailTransaction.transaction_status_formatted }}</v-chip>
							</div>
						</div>
						<div class="mt-3 text-right" v-if="detailTransaction.bonus_transfer_status_update_datetime">
							<div class="font-size-10">Tanggal Transfer</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailTransaction.bonus_transfer_status_update_datetime | tanggal }}</div>
						</div>
					</v-col>
				</v-row>
				
				<v-row>
					<v-col cols="12" md="12" class="pt-0">
						<div>
							<div class="font-size-10">Kode Mitra</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailTransaction.transaction_member_ref_network_code }}</div>
						</div>
						<div class="pt-2">
							<div class="font-size-10">Nama Mitra</div>
							<div class="font-size-10 cl-secondary font-weight-500">{{ detailTransaction.transaction_member_name }}</div>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="4" md="4" class="pr-0 border-bottom border-grey border-2px">
						<div class="font-size-10 font-weight-500">Item</div>
					</v-col>
					<v-col cols="4" md="4" class="px-1 text-center border-bottom border-grey border-2px">
						<div class="font-size-10 font-weight-500">Qty</div>
					</v-col>
					<v-col cols="4" md="4" class="pl-0 text-right border-bottom border-grey border-2px">
						<div class="font-size-10 font-weight-500">Total</div>
					</v-col>
					<v-col cols="12" class="pa-0">
						<div class="d-flex flex-wrap" v-for="product in detailTransaction.transaction_detail" :key="product.transaction_id">
							<v-col cols="4" md="4" class="pr-0 border-bottom border-grey border-2px">
								<div class="font-size-10">{{ product.transaction_detail_product_name }}</div>
								<div class="font-size-10">{{ parseInt(product.transaction_detail_unit_price) + parseInt(product.transaction_detail_product_admin_charge_value) - parseInt(product.transaction_detail_product_discount_value) | toRupiah }}</div>
							</v-col>
							<v-col cols="4" md="4" class="px-1 text-center border-bottom border-grey border-2px">
								<div class="font-size-10">{{ product.transaction_detail_qty }}</div>
							</v-col>
							<v-col cols="4" md="4" class="pl-0 text-right border-bottom border-grey border-2px">
								<div class="font-size-10">{{ ((parseInt(product.transaction_detail_unit_price) + parseInt(product.transaction_detail_product_admin_charge_value) - parseInt(product.transaction_detail_product_discount_value)) * product.transaction_detail_qty) | toRupiah }}</div>
							</v-col>
						</div>
					</v-col>
				</v-row>
				<v-row class="pt-3">
					<v-col cols="6" md="6" class="pr-0 border-bottom border-grey border-2px">
						<div class="font-size-10 font-weight-500">Total Pembayaran</div>
					</v-col>
					<v-col cols="6" md="6" class="pl-0 text-right border-bottom border-grey border-2px">
						<div class="font-size-10 font-weight-500">{{ detailTransaction.transaction_total_price | toRupiah }}</div>
					</v-col>
				</v-row>
			</div>

			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</v-col>
	</v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		...mapState('transactionProduct', ['detailTransaction']),

		sumTotal() {
			let total = 0
			if (Object.keys(this.detailTransaction) > 0) {
				this.detailTransaction.transaction_detail.forEach((el) => {
					total += (parseInt(el.transaction_detail_unit_price) + parseInt(el.transaction_detail_product_admin_charge_value) - parseInt(el.transaction_detail_product_discount_value)) * parseInt(el.transaction_detail_qty)
				})
				return total
			} else {
				return total
			}
		},
	},
	methods: {
		...mapActions('transactionProduct', ['getDetailTransaction']),

		goPrint() {
			window.print()
		}
	},
	async created() {
		const authData = await localStorage.getItem('mlmcore-vo-auth-data');
		const data = await JSON.parse(authData)

		await this.$store.dispatch('setPageTitle', `Print Pembelian Produk`)
		this.loading = await true
		await this.getDetailTransaction({ code: this.$route.params.slug }).then(() => {
			if (data.member_network_code !== this.detailTransaction.transaction_member_ref_network_code) {
				this.$router.push({name: 'lap-repeat-order'})
			} else {
				this.loading = false
			}
		}).catch(() => {
			this.loading = false
		})
	}
};
</script>